module.exports = __webpack_public_path__ + "img/order.81f8371b.png";